import type { ReactNode } from "react";
import { connect } from "react-redux";

import actions from "@/actions";

import Button from "../base/Button";

const renderIcon = (color: string): ReactNode => (
    <svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1">
        <title>copy</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g
            id="Lightsmap-2.0"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="square"
        >
            <g
                id="Select-Manual"
                transform="translate(-559.000000, -71.000000)"
                stroke={color}
            >
                <g id="toolbar" transform="translate(0.000000, 60.000000)">
                    <g
                        id="Group-6"
                        transform="translate(544.800000, 11.500000)"
                    >
                        <g id="copy" transform="translate(14.763071, 0.000000)">
                            <polyline
                                id="Shape"
                                points="17.4193548 6.58064516 23.6129032 6.58064516 23.6129032 23.6129032 6.58064516 23.6129032 6.58064516 17.4193548"
                            />
                            <rect
                                id="Rectangle-path"
                                x="0.387096774"
                                y="0.387096774"
                                width="17.0322581"
                                height="17.0322581"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const Copy = (props: React.ComponentProps<typeof Button>) => (
    <Button {...props} renderIcon={renderIcon} />
);

const mapStateToProps = ({ map }: { map: any }) => ({
    disabled: map.general.selectedLights.length <= 1,
});

const mapDispatchToProps = {
    onClick: actions.map.general.copy,
};

export default connect(mapStateToProps, mapDispatchToProps)(Copy);
